import { FC } from "react";
import { SimpleNav } from "~/components";
import { routes } from "~/constants";
import { trackPlanPayment as track } from "~/PlanDetailsApp/events";
import { Body, Meta } from "./components";

export const PlanPaymentPage: FC = () => {
  return (
    <>
      <Meta />
      <SimpleNav
        handleClick={track.goToPreviousPage}
        previousRoute={routes.planSelect}
      />
      <Body />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default PlanPaymentPage;
